import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=61e69278&scoped=true&"
import script from "./PersonForm.vue?vue&type=script&lang=ts&"
export * from "./PersonForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e69278",
  null
  
)

export default component.exports